import React, { useState, useContext } from 'react';
import { Modal, Form, Input, Upload, Button, Image, Select  } from 'antd';
import { UploadOutlined, DeleteOutlined } from '@ant-design/icons';
import { GlobalContext } from "../../../lib/context";


interface CustomDialogProps {
  isOpen: boolean;
  data: any;
  onClose: () => void;
  onSubmit: (formData: any) => void;
  editMode: boolean;
}

const CustomDialog: React.FC<CustomDialogProps> = ({ isOpen, data, onClose, onSubmit, editMode }) => {
  const [form] = Form.useForm();
  const imageBaseURL = `${process.env.REACT_APP_IMAGE_URL || ""}`;
  const { profile } = useContext(GlobalContext);
  
  const getFileNameFromPath = (imagePath: string) => {
    return imagePath ? imagePath.split('/').pop() || "" : "";
  };
  const [showUpload, setShowUpload] = useState(!editMode || !data?.image_name); // Show upload if no image exists
   // Check if user is editing their own account
  const isEditingSelf = editMode && profile?.id === data?.id;
   // Check if current user is admin
  const isAdmin = profile?.user_role === 'Admin';
     // Determine if status should be disabled
  const disableStatus = isEditingSelf && isAdmin;
  console.log(disableStatus)
  // On form submit
  const handleFormSubmit = () => {
    form.validateFields()
      .then(values => {
          // Additional validation for admin self-inactivation
          if (isEditingSelf && isAdmin && values.user_status === 'Inactive') {
            Modal.error({
              title: 'Invalid Operation',
              content: 'Administrators cannot deactivate their own account while logged in.'
            });
            return;
          }
        onSubmit(values); // Call the parent submit function with form data
        form.resetFields();
      })
      .catch(info => {
        console.log('Validation Failed:', info);
      });
  };

  // Handle picture deletion
  const handleDeletePicture = () => {
    setShowUpload(true); // Show upload section after deletion
    form.setFieldsValue({ profilePic: null }); // Clear the current profilePic value
  };

  return (
    <Modal
      title={editMode ? "Edit User" : "Add User"}
      open={isOpen}
      onCancel={() => {
        form.resetFields();
        onClose();
      }}
      onOk={handleFormSubmit}
    >
      <Form
        form={form}
        layout="vertical"
        initialValues={data}
      >
        <Form.Item name="id" noStyle>
          <Input type="hidden" value="id" />
        </Form.Item>

        {/* Display current profile picture if in edit mode and profile picture exists */}
        {editMode && data?.image_name && !showUpload && (
          <Form.Item label="Current Profile Picture">
            <Image
              src={imageBaseURL + getFileNameFromPath(data.image_name)}
              alt="Current Profile Picture"
              width={100}
              height={100}
              style={{ marginBottom: '10px', objectFit: 'cover' }}
            />
            <Button icon={<DeleteOutlined />} onClick={handleDeletePicture} type="link">
              Delete Picture
            </Button>
          </Form.Item>
        )}

        {/* Conditionally display the upload field */}
        {showUpload && (
          <Form.Item
            name="profilePic"
            label="Profile Picture"
            valuePropName="file"
            // rules={[{ required: true, message: 'Please upload a profile picture' }]}
          >
            <Upload listType="picture" maxCount={1} beforeUpload={() => false}>
              <Button icon={<UploadOutlined />}>Upload Profile Picture</Button>
            </Upload>
          </Form.Item>
        )}

        <Form.Item
          name="full_name"
          label="Full Name"
          rules={[{ required: true, message: 'Please enter your name' }]}
        >
          <Input placeholder="Enter full name" />
        </Form.Item>

        <Form.Item
          name="email"
          label="Email"
          rules={[{ required: true, type: 'email', message: 'Please enter a valid email' }]}
        >
          <Input placeholder="Enter email"
            disabled={editMode} // Make email readonly in edit mode
            className={editMode ? 'ant-input-disabled' : ''} // Optional: Add disabled styling
          />
        </Form.Item>
        <Form.Item
          name="user_status"
          label="User Status"
          rules={[{ required: true, message: 'Please select user status' }]}
          tooltip={disableStatus ? "Administrators cannot deactivate their own account while logged in" : undefined}
        >
          <Select placeholder="Select user status" disabled={disableStatus}>
            <Select.Option value="Active">Active</Select.Option>
            <Select.Option value="Inactive">Inactive</Select.Option>
          </Select>
        </Form.Item>
        <Form.Item
          name="user_role"
          label="User Role"
          rules={[{ required: true, message: 'Please select user type' }]}
          tooltip={disableStatus ? "Administrators cannot change their own role while logged in" : undefined}
        >
          <Select placeholder="Select user type" disabled={disableStatus}>
            <Select.Option value="admin">Admin</Select.Option>
            <Select.Option value="user">User</Select.Option>
          </Select>
        </Form.Item>

      </Form>
    </Modal>
  );
};

export default CustomDialog;

